import styled from "@emotion/styled";

export const UpperContainer = styled.div`
  display: flex;
  padding: 0px 20px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const MeetingRoomFilterSection = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const FilterChipContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

export const MainContainer = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  gap: 42px;
`;

export const MeetingRoomListContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  row-gap: 20px;
  column-gap: 20px;
`;

export const EmptyItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;
